import { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useParamQuery } from 'src/hooks';
import { useGetBulkReplaceRequests } from 'src/hooks/api/publication/useGetAssemblyPublicationList';
import { formatQuery, lang } from 'src/utils';

import { ASSEMBLY_PUBLICATION_LIST_COLUMN } from '../AssemblyPublicationPage.interface';

export const useAssemblyPublicationListPage = () => {
  const location = useLocation();

  const { onChangeParams } = useParamQuery({
    sort: ['-modified_at'],
  });

  const {
    data: listPublication,
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useGetBulkReplaceRequests(formatQuery(location.search), [
    'fromComponent',
    'toComponent',
  ]);

  const [activeColumn, setActiveColumn] = useState('');

  const [sorting, setSorting] = useState({
    columnKey: 'modified_at',
    order: 'desc',
  });

  const getNextListPublicationPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage]);

  const handleSort = (columnKey: string, order: string) => {
    setSorting(() => ({
      columnKey,
      order,
    }));
    setActiveColumn(columnKey);
    onChangeParams('sort', [
      `${order === 'asc' ? columnKey : `-${columnKey}`}`,
    ]);
  };

  const columns = [
    {
      label: lang.bulkReplaceName,
      key: ASSEMBLY_PUBLICATION_LIST_COLUMN.DISPLAY_NAME,
      sortIcon: true,
      width: 190,
    },
    {
      label: lang.noOfAssemblies,
      key: ASSEMBLY_PUBLICATION_LIST_COLUMN.NUM_ASSEMBLIES,
      sortIcon: false,
      width: 100,
    },
    {
      label: lang.fromComponent,
      key: ASSEMBLY_PUBLICATION_LIST_COLUMN.FROM_COMP,
      sortIcon: false,
      width: 220,
    },
    {
      label: lang.toComponent,
      key: ASSEMBLY_PUBLICATION_LIST_COLUMN.TO_COMP,
      sortIcon: false,
      width: 220,
    },
    {
      label: lang.user,
      key: ASSEMBLY_PUBLICATION_LIST_COLUMN.USER,
      sortIcon: true,
      width: 160,
    },
    {
      label: lang.lastModified,
      key: ASSEMBLY_PUBLICATION_LIST_COLUMN.LAST_MODIFIED,
      sortIcon: true,
      width: 200,
    },
  ];

  return {
    listPublication,
    isLoading,
    getNextListPublicationPage,
    columns,
    handleSort,
    activeColumn,
    sorting,
    hasNextPage,
  };
};
